'use strict';
import { j as r } from "../../external/react/jsx-runtime.js";
function i({ id: e, domain: t }) {
  return /* @__PURE__ */ r.jsx(
    "a",
    {
      href: `https://www.legitscript.com/websites/?checker_keywords=${t}`,
      title: `Verify LegitScript Approval for www.${t}`,
      className: "block pb-2 md:pb-1",
      target: "_blank",
      rel: "noreferrer",
      children: /* @__PURE__ */ r.jsx(
        "img",
        {
          src: `https://static.legitscript.com/seals/${e}.png`,
          alt: `Verify Approval for www.${t}`,
          width: 113,
          height: 100
        }
      )
    }
  );
}
export {
  i as default
};
